export default {
  banners: [
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
    {
      imgUrl: require("../../assets/images/contact/contact-banner.jpg"),
      title: "お問い合わせ",
      description: "MaesInfoへのお問い合わせはこちらからご連絡ください。",
      component: ""
    }
  ],
  contactUs: "お問い合わせ",
  a1: `成都市天府ソフトウェアパーク D6-13階 (中国)`,
  a2: `ワシントン州ベルヴィュー市、郵便番号98004 (アメリカ)`,
  p1: `+86(028) 6593-5363 (中国)`,
  p2: `+86 15928758550 (中国)`,
  p3: `+86 400-871-8663 (中国)`,
  p4: `+86 18349353270(中国)`,
  p5: `+880 1825459736 (バングラデシュ)`,
  p6: `+1 4258668398 (アメリカ)`,
  p7: `+60 182525593 (マレーシア)`,
  tips: `最も効果的な連絡手段は右下のライブチャットウィンドウをご利用ください。`,
  map: require("../../assets/images/contact/map2.png"),

  info: "MaesInfoは顧客と長期的な関係を築き、価値を創造してデジタルトランスフォーメーションを加速します。",
  address: [
    {
      title: "成都，中国",
      info: `住所: 成都市天府ソフトウェアパーク D6-13階 610041 <br/>
              電話: +86 (28) 6593-5363 <br/>
              FAX: +86(28) 8533-6315 <br/>
              メール: sales@maesinfo.cn`
    },
    {
      title: "深圳，中国",
      info: ""
    },
    {
      title: "常州，中国",
      info: ""
    },
    {
      title: "ワシントン，アメリカ",
      info: ""
    }
  ],
  qrCode: {
    qrImg: require("../../assets/images/contact/qrcode.png"),
    title: "iPhone / Android",
    description: "Melinkedでお問い合わせください",
    url: "https://www.melinked.com"
  }
};
